import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCGRfkkBPbzdq-agO5D2DR47OP-KYfONGE",
  authDomain: "aeroswath-platform.firebaseapp.com",
  projectId: "aeroswath-platform",
  storageBucket: "aeroswath-platform.firebasestorage.app",
  messagingSenderId: "251378028562",
  appId: "1:251378028562:web:64cec16b203fe76f6388cb",
  measurementId: "G-J0X4FLFTB5",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
